import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Contrato extends CoreBase implements IContrato {
  async getAllPrestadores(): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.getAllPrestadores()
    return response
  }

  async getAllContratos(prestadorId: string): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.getAllContratos(prestadorId)
    return response
  }

  async getAllRegrasDisponiveis(contratoId: string): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.getAllRegrasDisponiveis(contratoId)
    return response
  }

  async getAllProfissionais(): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.getAllProfissionais()
    return response
  }

  async getAllGestores(): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.getAllGestores()
    return response
  }

  async getContratoById(contratoId: string): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.getContratoById(contratoId)
    return response
  }

  async deleteRegrasByContratoId(contratoId: string, regraId: string): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.deleteRegrasByContratoId(contratoId, regraId)
    return response
  }

  async deleteProfissionaisByContratoId(contratoId: string, profissionaisIds: string[]): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.deleteProfissionaisByContratoId(contratoId, profissionaisIds)
    return response
  }

  async deleteGestoresByContratoId(contratoId: string, gestoresIds: string[]): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.deleteGestoresByContratoId(contratoId, gestoresIds)
    return response
  }

  async postRegrasByContratoId(contratoId: string, regrasIds: string[]): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.postRegrasByContratoId(contratoId, regrasIds)
    return response
  }

  async postProfissionaisByContratoId(contratoId: string, profissionaisIds: string[]): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.postProfissionaisByContratoId(contratoId, profissionaisIds)
    return response
  }

  async postGestoresByContratoId(contratoId: string, gestoresIds: string[]): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.postGestoresByContratoId(contratoId, gestoresIds)
    return response
  }

  async removeContratoGestor(params: any): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.removeContratoGestor(params)
    return response
  }

  async addGestor(contratoId: string, params: any): Promise<ResponseApi> {
    const response = await Apis.Contrato.ContratoApi.addGestor(contratoId, params)
    return response
  }
}

interface IContrato extends ICoreBase {
  getAllPrestadores(): Promise<ResponseApi>
  getAllContratos(prestadorId: string): Promise<ResponseApi>
  getAllRegrasDisponiveis(contratoId: string): Promise<ResponseApi>
  getAllProfissionais(): Promise<ResponseApi>
  getAllGestores(): Promise<ResponseApi>
  getContratoById(contratoId: string): Promise<ResponseApi>
  deleteRegrasByContratoId(contratoId: string, regraId: string): Promise<ResponseApi>
  deleteProfissionaisByContratoId(contratoId: string, profissionaisIds: string[]): Promise<ResponseApi>
  deleteGestoresByContratoId(contratoId: string, gestoresIds: string[]): Promise<ResponseApi>
  postRegrasByContratoId(contratoId: string, regrasIds: string[]): Promise<ResponseApi>
  postProfissionaisByContratoId(contratoId: string, profissionaisIds: string[]): Promise<ResponseApi>
  postGestoresByContratoId(contratoId: string, gestoresIds: string[]): Promise<ResponseApi>
}

export {
  Contrato,
  IContrato,
}
